import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import markLogoImg from '../../assets/images/mark-logo.svg';

interface LoadingContainerProps {
    visible: boolean;
}

const LoadingIcon = styled(FontAwesomeIcon)`
    font-size: 3rem;
    animation: loadingRotate 4000ms infinite;
    margin-bottom: 1rem;

    @keyframes loadingRotate {
        0% {
            transform: rotate(0turn);
        }
        100% {
            transform: rotate(1turn);
        }
    }
`;

const MarkLogo = styled.img`
    display: block
    width: clamp(100px, 8vw, 200px);
    height: auto;
`;

const LoadingContainer = styled.div<LoadingContainerProps>`
    position: fixed;
    z-index: 100000;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    overflow: none;
    opacity: ${({ visible })=> (visible ? 1 : 0)};
    visibility: ${({ visible })=> (visible ? 'visible' : 'hidden')};
    
    transition: all 500ms;
    background: radial-gradient(circle at 45% 10%, #4c04b8 0%, rgba(48,10,92,0.75) 40%, rgba(0, 0, 0, 0.5) 90%);
    background-attachment: fixed;
    background-position: center;
    background-size: 100%;
    backdrop-filter: blur(100px);
`;

const Message = styled.p`
    font-family: 'Roboto';
    font-size: 1rem;
    margin-top: 1rem;
`

const Loading: React.FC<LoadingContainerProps> = ({visible}) => {

    const [message, setMessage] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setMessage(true);
        }, 2000)
    });


    return (
        <LoadingContainer visible={visible}>
            <MarkLogo src={markLogoImg}/>
            {/* <LoadingIcon icon={faSpinner} /> */}
            <Message style={{opacity: message ? 1 : 0}}>Sorry, Cheap Server!</Message>
        </LoadingContainer>
    );
};

export default Loading;